import { ClientType, UserSession, UserType } from "generated/graphql";
import { Config } from "../Config";
import { stringContains } from "./coll";

const getPendo = () => {
  return (window as any).pendo;
};

export type Event =
  | "lens_case_export"
  | "case_form_export"
  | "login_fail"
  | "invite_user"
  | "invite_user_resend"
  | "invite_collect_user"
  | "invite_collect_user_resend"
  | "user_onboarded"
  | "dismiss_hit"
  | "edit_note"
  | "edit_date";

const computeId = (userId: number) => {
  const frontendBase = Config.frontendBase.toLowerCase();

  const envPrefix = stringContains(frontendBase, "develop")
    ? "develop_"
    : stringContains(frontendBase, "localhost")
      ? "local_"
      : "";
  return envPrefix + userId;
};

const Pendo = {
  initialize: (
    session: UserSession,
    appVersion: number,
    userType: UserType,
    firstName: string,
    lastName: string,
    clientType?: ClientType
  ): void => {
    const userId = computeId(session.userId);
    const clientId = computeId(session.clientId);
    getPendo().initialize({
      visitor: {
        id: userId, // Required if user is logged in
        email: session.email, // Recommended if using Pendo Feedback, or NPS Email
        createdAt: session.userCreatedAt,
        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
        appVersion,
        userType,
        firstName,
        lastName,
      },
      account: {
        id: clientId,
        clientType,
      },
      excludeAllText: true,
    });
  },
  event: (name: Event, params: Record<string, unknown>): void => {
    getPendo().track(name, params);
  },
};
export default Pendo;
